import React, { Component } from "react";
import { Button, Icon, Radio, notification } from "antd";
import { omisekey, sellername, currency } from "../../config";
class OmiseInternetBanking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      btnLoginloading: false,
    };

    this.callOmise = this.callOmise.bind(this);
  }

  componentDidMount() {
    const OmiseCard = window.OmiseCard;

    OmiseCard.configure({
      publicKey: omisekey,
      frameLabel: sellername,
    });

    this.setState({
      OmiseCreditCard: OmiseCard,
    });
    console.table(this.props.packagecost);
  }

  callOmise(e) {
    e.preventDefault();
    this.props.setLoading(true);
    this.props.setMessage("Waiting for your internet_banking info...", null);

    console.log("test callOmise credit card");
    console.log(this.props.data);
    let inputData = this.props.data;
    let message = "";
    if(this.props.showtaxinvoice){
        if (inputData.mobile !== "") {
        const regex = new RegExp("^[0][0-9]{9}$");
        console.log("check mobile", regex.test(inputData.mobile));
        if (!regex.test(inputData.mobile)) {
            message = "เบอร์โทรศัพท์กรอกไม่ถูกต้อง";
            this.props.CheckBtnPayment(message);
        }
        }
        if (inputData.idcard !== "") {
        const regex = new RegExp("[0-9]{13}$");
        console.log("idcard", inputData.idcard);
        console.log("check idcard", regex.test(inputData.idcard));
        if (!regex.test(inputData.idcard)) {
            message = "id card กรอกไม่ถูกต้อง";
            this.props.CheckBtnPayment(message);
        }
        }
        if (inputData.typetax === 1) {
        if (
            inputData.name === "" ||
            inputData.mobile === "" ||
            inputData.idcard === ""
        ) {
            message = "กรุณากรอกข้อมูลให้ครบถ้วน";
            this.props.CheckBtnPayment(message);
        }
        } else if (inputData.typetax === 2) {
        if (
            inputData.name === "" ||
            inputData.branch === "" ||
            inputData.mobile === "" ||
            inputData.idcard === "" ||
            inputData.address === "" ||
            inputData.province === "" ||
            inputData.district === "" ||
            inputData.subdistrict === "" ||
            inputData.post === ""
        ) {
            message = "กรุณากรอกข้อมูลให้ครบถ้วน";
            this.props.CheckBtnPayment(message);
        }
        }
    }
    if (message === "") {
      this.props.CheckBtnPayment("");
      window.OmiseCard.open({
        amount: this.props.packagecost * 100,
        currency: currency,
        defaultPaymentMethod: "internet_banking",
        onCreateTokenSuccess: (nonce) => {
          console.table(nonce);

          if (nonce.startsWith("src_")) {
            if (this.props.AutoCheckout) {
              this.props.ProcessPayment(nonce, "internet_banking_bay");
            }
          } else {
            notification.open({
              message: "Failed to create payment",
              description:
                "Cannot connect to Payment operator. Please try again later.",
              top: 60,
              className: "rti_form r",
            });
          }
        },
        onFormClosed: () => {
          this.props.setLoading(false);
        },
      });
    }
  }

  beforeSubmit(e) {
    console.table(this.state);
    e.preventDefault();
  }

  render() {
    let { btnLoginloading } = this.state;

    return (
      <form id="CheckOutWithInternetBanking" onSubmit={this.beforeSubmit}>
        <Button
          style={{ backgroundColor: "#EA7326", color: "#fff" }}
          loading={btnLoginloading}
          onClick={this.callOmise}
        >
          Payment
        </Button>
      </form>
    );
  }
}

export default OmiseInternetBanking;
